<template>
  <div>
    <w-loading-spinner :loadSpinner="loading" />
    <c-summary-navbar
      :userName="eipUserName"
      :protalName="'Customer Registration'"
      @userLogout="logout()"
    />
    <div style="background:#fefefe;margin: 0px 50px;padding: 20px;" v-if="!isCreate && !isView">
      <span style="float: left;font-weight: bold;font-size: 20px;">Customer List</span>
      <div class="linker" style="float:left;margin-left:20px">
        <b-button variant="primary" @click="goToEIP4()">Go to EIP4</b-button>
      </div>
      <span
        style="float:right;margin-left:20px"
        class="btn btn-primary"
        @click="resetForm();isCreate=true"
      >Add New Customer +</span>
      <span
        v-if="false"
        style="float:right;margin-left:10px"
        class="btn btn-primary"
      >&#x1F50E;&#xFE0E;</span>
      <span style="float:right;">
        <input
          type="text"
          v-model="searchTerm"
          id="workflow-history"
          @input="onSearch()"
          placeholder="Search Customer, Min 4 chars"
          class="form-control"
          style="width: 300px;"
        />
      </span>
      <div class="my-custom-scrollbar table-responsive customerlist" style="padding-top:15px;">
        <vue-good-table
          @on-page-change="onPageChange"
          @on-per-page-change="onPageChange"
          :totalRows="totalRecords"
          :columns="columns"
          :rows="customerList"
          max-height="500px"
          :fixed-header="true"
          :search-options="{
    enabled: false
  }"
          :pagination-options="{
    enabled: true,
    perPage: 50
  }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'actions'">
              <button class="btn btn-primary custom-btn" @click="viewDetails(props.row)">View</button>
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>

    <div style="background:#fefefe;margin: 0px 50px;padding: 20px;" v-if="isCreate || isView">
      <div style="text-align:left;font-size:18px;font-weight:bold;">
        Customer {{!isView ? 'Registration Form' : 'Details'}}
        <span
          style="float:right;"
          class="btn btn-primary"
          @click="resetFilter();getCustomerList();isCreate=false;isView=false;"
        >Go Back</span>
        <div style="font-size:14px;padding: 10px 5px;">
          {{masterData.isMigrated == 'Yes' ? 'Migrated Customer | ' : ''}}
          {{masterData.isMigrated == 'Yes' ? 'EIP Customer Id: ' + masterData.migratedCustomerId + ' | ': ''}}
          {{viewPI? 'PI Number: '+viewPI : ''}} {{documentNumber? ' | Doc Number: '+documentNumber +' |': ''}}
          <span
            v-html="getStatus()"
          ></span>
        </div>
        <div
          v-if="workflowRemarks && (documentStatus == 'S' || documentStatus == 'R')"
          style="font-size: 14px;font-weight: normal;padding-bottom:13px;"
        >WorkFlow Remarks: {{workflowRemarks ? workflowRemarks:''}}</div>
      </div>
      <div :class="isView? 'disabled':''" style="padding:5px;">
        <div class="headingss">Basic Details</div>
        <b-button id="tooltip-target-1" variant="outline-info" size="sm">ℹ</b-button>
        <b-tooltip
          target="tooltip-target-1"
          triggers="hover"
        >Register using TAN number for government Institute</b-tooltip>
        <div class="row m-0 customerregform">
          <div class="col-12 col-md-6 col-lg-3">
            <b-form-group class="exo-regular field-headings" :label="'Country'">
              <w-dropdown
                class="width-control-small"
                :options="countryList"
                validation="required"
                @dropdownChange="getCountry($event)"
                :selected="form.countryCode"
                :disabled="false"
              />
            </b-form-group>
          </div>
          <!-- {{form.organisationDetail.registeredOfficeAddress.streetAddress}} -->
          <div class="col-12 col-md-6 col-lg-3" v-if="form.countryCode == 100">
            <b-form-group class="source-sans-pro field-headings">
              <w-text-input
                :labelName="$t('PAN Number/TAN number')"
                @textInputChange="getPan($event)"
                validation="required|regex_pan_tannumber|max:10|min:10"
                :defaultValue="form.statutory.panNumber"
                :disabled="false"
                :maxCharacter="'10'"
                :errorMessage="$t('PAN Number/TAN number')"
              />
            </b-form-group>
          </div>

          <div class="col-12 col-md-6 col-lg-3" v-if="form.countryCode != 100">
            <b-form-group class="source-sans-pro field-headings">
              <w-text-input
                :labelName="$t('Company Registration Number')"
                @textInputChange="getCRN($event)"
                validation="required|regex_alpha_numeric|max:30|min:4"
                :defaultValue="form.statutory.cinNumber"
                :disabled="false"
                :maxCharacter="'30'"
              />
            </b-form-group>
          </div>

          <div class="col-md-6 col-lg-3">
            <b-form-group class="exo-regular field-headings" :label="'Select Company'">
              <w-dropdown
                class="width-control-small"
                :options="companyList"
                :disabled="false"
                @dropdownChange="getCompanyChange($event)"
                :selected="form.companyCode"
                autocomplete="off"
              />
            </b-form-group>
          </div>
          <!--div class="col-md-6 col-lg-3">
    <b-form-group
      class="exo-regular field-headings"
      :label="'Select Category'"
    >
   <w-dropdown
      class="width-control-small"
      :options="categoryList"
      :disabled="categoryList.length == 1 && categoryList[0].text=='Select One'"
      @dropdownChange="getCategoryChange($event)"
      :selected="form.categoryCode"
      autocomplete="off"
    />
    </b-form-group>      
          </div-->
        </div>
        <div class="row m-0 customerregform">
          <div class="col-md-6 col-lg-3">
            <w-text-input
              :labelName="'Customer Name'"
              @textInputChange="getCustomerName($event)"
              validation="required"
              autocomplete="off"
              :defaultValue="form.customerName"
              :errorMessage="'Customer name'"
              :maxCharacter="'150'"
            />
          </div>
          <div class="col-md-6 col-lg-3">
            <b-form-group class="exo-regular field-headings" :label="'Select Sector'">
              <w-dropdown
                class="width-control-small"
                :options="sectorList"
                :disabled="false"
                @dropdownChange="getSectorChange($event)"
                :selected="selectedSector"
                autocomplete="off"
              />
            </b-form-group>
          </div>
          <div class="col-md-6 col-lg-3">
            <b-form-group class="exo-regular field-headings" :label="'Select Nature'">
              <w-dropdown
                class="width-control-small"
                :options="natureList"
                :disabled="false"
                @dropdownChange="getNatureChange($event)"
                :selected="selectedNature"
                autocomplete="off"
              />
            </b-form-group>
          </div>

          <div class="col-md-6 col-lg-3">
            <b-form-group class="exo-regular field-headings" :label="'Select Customer Group'">
              <w-dropdown
                class="width-control-small"
                :options="customerGroupList"
                :disabled="false"
                @dropdownChange="getGroupChange($event)"
                :selected="selectedGroup"
                autocomplete="off"
              />
            </b-form-group>
          </div>
        </div>
        <hr />

        <div class="headingss">Contact Details</div>
        <div class="row m-0 customerregform">
          <div class="col-12 col-md-6 col-lg-3">
            <w-text-input
              :labelName="$t('Contact Name')"
              @textInputChange="getContactName($event)"
              validation="required|regex_alpha_numeric_space"
              :defaultValue="form.contact.contactName"
              :allowOnlyCharacters="true"
              :maxCharacter="'100'"
              :errorMessage="$t('Contact Name')"
            />
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <w-text-input
              :labelName="$t('Email')"
              @textInputChange="getEmailId($event)"
              :validation="'required|email'"
              :defaultValue="form.contact.email"
              :maxCharacter="'100'"
              :errorMessage="$t('Email')"
            />
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <w-text-input
              :labelName="$t('Mobile Number*')"
              @textInputChange="getMobileNumber($event)"
              :validation="mobileValidationObj()"
              :defaultValue="form.contact.mobileNumber"
              :errorMessage="$t('Mobile Number')"
              :type="'number'"
              :inputAdditions="'mobile'"
              :maxDigits="phoneNumberLength"
              :disabled="form.countryCode==''"
              :isdCode="isdCode"
            />
          </div>

          <div class="col-12 col-md-6 col-lg-3">
            <button
              @click="registerCustomer()"
              class="btn btn-primary"
              style="position: absolute;bottom: 15px;"
              v-if="!isView"
            >Register</button>
          </div>
        </div>
      </div>
      <div
        v-if="isView"
        style="padding:5px;"
        :class="documentStatus=='R' || documentStatus=='C' || documentStatus=='A'? 'disabled':''"
      >
        <hr />
        <div class="headingss">Address Details</div>
        <div class="row m-0 customerregform">
          <!-- {{form.organisationDetail.registeredOfficeAddress.streetAddress}} -->
          <div class="col-12">
            <b-form-group class="source-sans-pro field-headings">
              <w-text-input
                :labelName="$t('Address')"
                @textInputChange="getStreetAddress($event)"
                validation="required|min:10|max:100"
                :defaultValue="onboardingDetails.registeredOfficeAddress.streetAddress"
                :disabled="false"
                :maxCharacter="'500'"
                :errorMessage="$t('Street address')"
              />
            </b-form-group>
          </div>
        </div>
        <div class="row m-0 customerregform">
          <div class="col-12 col-md-6 col-lg-3">
            <b-form-group class="source-sans-pro field-headings" label="Country">
              <w-dropdown
                class="width-control-small"
                :options="countryList"
                validation="required"
                @dropdownChange="getCountry($event)"
                :selected="onboardingDetails.registeredOfficeAddress.countryCode"
                :disabled="true"
              />
            </b-form-group>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <b-form-group class="source-sans-pro field-headings" label="State">
              <w-dropdown
                class="width-control-small"
                :options="stateList"
                validation="required"
                @dropdownChange="getState($event)"
                :selected="onboardingDetails.registeredOfficeAddress.stateCode"
                :disabled="false"
              />
            </b-form-group>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <b-form-group class="source-sans-pro field-headings" label="City">
              <w-dropdown
                class="width-control-small"
                :options="cityList"
                validation="required"
                @dropdownChange="getCity($event)"
                :selected="onboardingDetails.registeredOfficeAddress.cityCode"
                :disabled="false"
              />
            </b-form-group>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <w-text-input
              :labelName="$t('ZipCode')"
              @textInputChange="getZipcode($event)"
              :validation="zipValidation(onboardingDetails.registeredOfficeAddress.countryCode)"
              :defaultValue="onboardingDetails.registeredOfficeAddress.postalCode"
              :disabled="false"
              :inputAdditions="'mobile'"
              :errorMessage="$t('Zipcode')"
            />
          </div>
        </div>
        <hr />
        <div class="headingss" style="width:100%">Statutory Details</div>
        <div class="row customerregform" v-if="form.countryCode==100">
          <div class="col-12 col-md-6 col-lg-3 mt-2" style="padding: 0px 30px;">
            <h6 class="m-0 mb-3 sub-heading">GST Number *</h6>
            <div style>
              <b-form-group label>
                <b-form-radio-group
                  v-model="form.statutory.isGstNumber"
                  @change="checkRadioGst()"
                  :options="[
          { text: 'Yes', value: 'Y' },
          { text: 'No', value: 'N' }        ]"
                ></b-form-radio-group>
              </b-form-group>
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-3 mt-2" v-if="form.statutory.isGstNumber == 'Y'">
            <w-text-input
              :labelName="$t('GST Number')"
              @textInputChange="getGstNumber($event)"
              validation="required|regex_gst"
              :defaultValue="onboardingDetails.gstNumber"
              :maxCharacter="'50'"
              :errorMessage="$t('GST Number')"
            />
            <p
              class="mt-n2 font-weight-bold text-danger lato-regular"
              v-if="gstDuplicate == true"
            >GST Number is already used</p>
          </div>

          <div class="col-12 col-md-6 col-lg-3 mt-2 p-0 m-0">
            <FileUploader
              :heading="form.statutory.isGstNumber == 'N'?'Attach Relevant documents/proofs':'Attach GST certificate'"
              @fileInputChange="uploadDocument($event, 'gst')"
            />

            <ul style="list-style-type:disc;" v-if="onboardingDetails.gstinDeclarationDocumentId">
              <li>
                <a
                  @click="showAttachFile(onboardingDetails.gstinDeclarationDocumentId)"
                  href="#"
                  class="mt-n2"
                >{{getFileName(onboardingDetails.gstinDeclarationDocumentId)}}</a>
              </li>
            </ul>
            <ul style="list-style-type:disc;" v-if="onboardingDetails.gstinDocumentId">
              <li>
                <a
                  @click="showAttachFile(onboardingDetails.gstinDocumentId)"
                  href="#"
                  class="mt-n2"
                >{{getFileName(onboardingDetails.gstinDocumentId)}}</a>
              </li>
            </ul>
          </div>
        </div>

        <div class="row customerregform" v-if="form.countryCode==100">
          <div class="col-12 col-md-6 col-lg-3 mt-2" style="padding: 0px 30px;">
            <h6 class="m-0 mb-3 sub-heading">TAN Number *</h6>
            <div style>
              <b-form-group label>
                <b-form-radio-group
                  v-model="form.statutory.isTanNumber"
                  @change="checkRadioTan()"
                  :options="[
          { text: 'Yes', value: 'Y' },
          { text: 'No', value: 'N' }        ]"
                ></b-form-radio-group>
              </b-form-group>
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-3 mt-2" v-if="form.statutory.isTanNumber == 'Y'">
            <w-text-input
              :labelName="$t('TAN Number')"
              @textInputChange="getTanNumber($event)"
              validation="required|regex_alpha_tan|max:10|min:10"
              :defaultValue="onboardingDetails.tanNumber"
              :maxCharacter="'50'"
              :errorMessage="$t('TAN Number')"
            />
            <p
              class="mt-n2 font-weight-bold text-danger lato-regular"
              v-if="tanDuplicate == true"
            >TAN Number is already used</p>
          </div>

          <div class="col-12 col-md-6 col-lg-3 mt-2 p-0 m-0">
            <FileUploader
              :heading="form.statutory.isTanNumber == 'N'?'Attach Relevant documents/proofs':'Attach TAN certificate'"
              @fileInputChange="uploadDocument($event, 'tan')"
            />

            <ul style="list-style-type:disc;" v-if="onboardingDetails.tanDeclarationDocumentId">
              <li>
                <a
                  @click="showAttachFile(onboardingDetails.tanDeclarationDocumentId)"
                  href="#"
                  class="mt-n2"
                >{{getFileName(onboardingDetails.tanDeclarationDocumentId)}}</a>
              </li>
            </ul>
            <ul style="list-style-type:disc;" v-if="onboardingDetails.tanDocumentId">
              <li>
                <a
                  @click="showAttachFile(onboardingDetails.tanDocumentId)"
                  href="#"
                  class="mt-n2"
                >{{getFileName(onboardingDetails.tanDocumentId)}}</a>
              </li>
            </ul>
          </div>
        </div>

        <div class="row customerregform" v-if="form.countryCode != 100">
          <div class="col-12 col-md-6 col-lg-3 mt-2" style="padding: 0px 30px;">
            <h6 class="m-0 mb-3 sub-heading">VAT Registration Number *</h6>
            <div style>
              <b-form-group label>
                <b-form-radio-group
                  v-model="form.statutory.isVatNumber"
                  @change="checkRadioVat()"
                  :options="[
          { text: 'Yes', value: 'Y' },
          { text: 'No', value: 'N' }        ]"
                ></b-form-radio-group>
              </b-form-group>
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-3 mt-2" v-if="form.statutory.isVatNumber == 'Y'">
            <w-text-input
              :labelName="$t('VAT Registration Number')"
              @textInputChange="getVatNumber($event)"
              validation="required|regex_vat|min:5|max:20"
              :defaultValue="onboardingDetails.vatNumber"
              :maxCharacter="'50'"
              :errorMessage="$t('VAT Number')"
            />
            <p
              class="mt-n2 font-weight-bold text-danger lato-regular"
              v-if="vatDuplicate == true"
            >VAT Number is already used</p>
          </div>

          <div class="col-12 col-md-6 col-lg-3 mt-2 p-0 m-0">
            <FileUploader
              :heading="form.statutory.isVatNumber == 'N'?'Attach Relevant documents/proofs':'Attach VAT Registration certificate'"
              @fileInputChange="uploadDocument($event, 'vat')"
            />

            <ul style="list-style-type:disc;" v-if="onboardingDetails.vatDeclarationDocumentId">
              <li>
                <a
                  @click="showAttachFile(onboardingDetails.vatDeclarationDocumentId)"
                  href="#"
                  class="mt-n2"
                >{{getFileName(onboardingDetails.vatDeclarationDocumentId)}}</a>
              </li>
            </ul>
            <ul style="list-style-type:disc;" v-if="onboardingDetails.vatDocumentId">
              <li>
                <a
                  @click="showAttachFile(onboardingDetails.vatDocumentId)"
                  href="#"
                  class="mt-n2"
                >{{getFileName(onboardingDetails.vatDocumentId)}}</a>
              </li>
            </ul>
          </div>
        </div>

        <hr />
        <div class="headingss" style="width:100%">Financial Details</div>

        <div class="row m-0 customerregform">
          <!-- {{form.organisationDetail.registeredOfficeAddress.streetAddress}} -->
          <div class="col-12 col-md-6 col-lg-3">
            <b-form-group class="source-sans-pro field-headings">
              <w-text-input
                :labelName="$t('Last financial year turnover')"
                @textInputChange="getTurnOver($event)"
                validation="required"
                :defaultValue="onboardingDetails.year1.turnover"
                :disabled="false"
                :maxCharacter="'10'"
                :type="'number'"
              />
            </b-form-group>

            <div class style="margin-top: -20px;">
              <FileUploader
                :heading="'Attach Balance sheet document/proof'"
                @fileInputChange="uploadDocument($event, 'bs')"
              />

              <ul
                style="list-style-type:disc;"
                v-if="onboardingDetails.year1.balanceSheetAttachment"
              >
                <li>
                  <a
                    @click="showAttachFile(onboardingDetails.year1.balanceSheetAttachment)"
                    href="#"
                    class="mt-n2"
                  >{{getFileName(onboardingDetails.year1.balanceSheetAttachment)}}</a>
                </li>
              </ul>
            </div>
          </div>
          <!-- {{form.organisationDetail.registeredOfficeAddress.streetAddress}} -->
          <div class="col-12 col-md-6 col-lg-3" v-if="!$root.isInternational">
            <b-form-group class="source-sans-pro field-headings">
              <w-text-input
                :labelName="$t('Last financial year ITR filing ack.number')"
                @textInputChange="getITRFilingNumber($event)"
                validation="required|min:15|max:15"
                :defaultValue="onboardingDetails.year1.itrReference"
                :disabled="false"
                :maxCharacter="'15'"
                :type="'number'"
                :errorMessage="$t('ITR Ack No')"
              />
            </b-form-group>

            <div class style="margin-top: -20px;">
              <FileUploader
                :heading="'Attach Relevant documents/proofs'"
                @fileInputChange="uploadDocument($event, 'itr')"
              />

              <ul style="list-style-type:disc;" v-if="onboardingDetails.year1.itrAttachment">
                <li>
                  <a
                    @click="showAttachFile(onboardingDetails.year1.itrAttachment)"
                    href="#"
                    class="mt-n2"
                  >{{getFileName(onboardingDetails.year1.itrAttachment)}}</a>
                </li>
              </ul>
            </div>
          </div>
          <!-- {{form.organisationDetail.registeredOfficeAddress.streetAddress}} -->
          <div class="col-12 col-md-6 col-lg-3" v-if="false">
            <b-form-group class="source-sans-pro field-headings">
              <w-text-input
                :labelName="$t('Last year GST filing ack.number')"
                @textInputChange="getGSTFilingNumber($event)"
                validation="required"
                :defaultValue="form.financial.gstRefNumber"
                :disabled="false"
                :maxCharacter="'10'"
              />
            </b-form-group>

            <div class style="margin-top: -20px;">
              <FileUploader
                :heading="'Attach Relevant documents/proofs'"
                @fileInputChange="uploadDocument($event, 'gstFiling')"
              />

              <ul style="list-style-type:disc;" v-if="form.financial.gstFilingDocId">
                <li>
                  <a
                    @click="showAttachFile(form.financial.gstFilingDocId)"
                    href="#"
                    class="mt-n2"
                  >{{getFileName(form.financial.gstFilingDocId)}}</a>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-12 col-md-6 col-lg-3">
            <b-form-group class="source-sans-pro field-headings">
              <w-text-input
                :labelName="$t('CRISIL Rating')"
                @textInputChange="getCrislRating($event)"
                validation="required|regex_creditrating"
                :defaultValue="onboardingDetails.ratings[0].agencyRating"
                :disabled="false"
                :maxCharacter="'10'"
                :errorMessage="$t('Rating')"
              />
            </b-form-group>

            <div class style="margin-top: -20px;">
              <FileUploader
                :heading="'Attach Relevant documents/proofs'"
                @fileInputChange="uploadDocument($event, 'rating')"
              />

              <ul
                style="list-style-type:disc;"
                v-if="onboardingDetails.ratings[0].ratingDocumentId"
              >
                <li>
                  <a
                    @click="showAttachFile(onboardingDetails.ratings[0].ratingDocumentId)"
                    href="#"
                    class="mt-n2"
                  >{{getFileName(onboardingDetails.ratings[0].ratingDocumentId)}}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <hr />
        <div class="headingss" style="width:100%">Bank Details</div>
        <div class="card-background">
          <table class="table table-striped mb-0">
            <thead>
              <tr class="oldbankheader th-left">
                <th>Account Category</th>
                <th>Account Number</th>
                <th>Payment in favour of</th>
                <th>Account Type</th>
                <th>Payment Mode</th>
                <th>Bank Name</th>
                <th v-if="form.countryCode == 100">IFSC Code</th>
                <th v-if="form.countryCode != 100">Swift Code</th>
                <th v-if="form.countryCode != 100">IBAN Number</th>
                <th v-if="form.countryCode != 100">Sort Code</th>
                <th>Attachment</th>
                <th>Payment Ref Email</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody class="text-left">
              <tr v-for="(bank,index) in customerBankList ? customerBankList : []" :key="index">
                <td>{{bank.accountCategory}}</td>
                <td>{{bank.accountNumber}}</td>
                <td>{{bank.paymentInfavourOf}}</td>
                <td>{{bank.accountType}}</td>
                <td>{{bank.paymentMode}}</td>
                <td>{{bank.bankName}}</td>
                <td v-if="form.countryCode == 100">{{bank.ifscCode}}</td>
                <td v-if="form.countryCode != 100">{{bank.swiftBicCode}}</td>
                <td v-if="form.countryCode != 100">{{bank.ibanNumber}}</td>
                <td v-if="form.countryCode !=100">{{bank.sortCode}}</td>>
                <td>
                  <a
                    v-if="bank.documentId!=null"
                    @click="showFile(bank.documentId)"
                    href="#"
                  >{{getAttachmentName(bank.documentId)}}</a>
                  <span v-else>-</span>
                </td>
                <td>{{bank.paymentRefMailId}}</td>
                <td>
                  <button class="btn-border">
                    <img
                      class="pr-2 mt-1 cursor-pointer"
                      width="32px"
                      src="@/assets/delete_Icon.svg"
                      alt="icon"
                      title="Delete"
                      animation="true"
                      @click="deleteBankDetail(bank)"
                    />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-12 col-md-6 col-lg-3" style=" text-align: left;padding: 10px 20px;">
          <button
            @click="triggerBankModal=true"
            class="btn btn-primary"
            v-if="documentStatus=='N' || documentStatus=='S' || documentStatus == null"
          >Add Bank +</button>
        </div>

        <hr v-if="!isBranch" />
        <div class="headingss" style="width:100%" v-if="!isBranch">Branch Details</div>
        <div class="new-branch-details-table" v-if="!isBranch">
          <table class="table table-striped mb-0">
            <thead>
              <tr class="th-left">
                <th>Branch Id</th>
                <th>Branch Name</th>
                <th>Document Number</th>
                <th>Contact Person Name</th>
                <th>Contact Number</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody class="text-left">
              <tr v-for="cbr in customerBranchList" v-bind:key="cbr">
                <td>{{cbr.branchId}}</td>
                <td>{{cbr.branchName}}</td>
                <td>{{cbr.documentNumber ? cbr.documentNumber : '-Yet to be generated-'}}</td>
                <td>{{cbr.contactPersonName}}</td>
                <td>{{cbr.mobileNumber}}</td>
                <td>
                  <button class="btn-border">
                    <img
                      class="pr-2 mt-1 cursor-pointer"
                      width="32px"
                      src="@/assets/delete_Icon.svg"
                      alt="icon"
                      title="Delete"
                      animation="true"
                      @click="deleteBranchDetail(cbr)"
                    />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="col-12 col-md-6 col-lg-3"
          style=" text-align: left;padding: 10px 20px;"
          v-if="!isBranch"
        >
          <button
            @click="triggerAddBranchModal=true"
            class="btn btn-primary"
            v-if="documentStatus=='N' || documentStatus=='S' || documentStatus == null"
          >Add Branch +</button>
        </div>
        <hr />
        <div class="col-12" style="padding: 10px 20px;">
          <button
            @click="saveCustomerDetails()"
            class="btn btn-primary"
            v-if="documentStatus=='N' || documentStatus==null"
          >Save Draft</button>
          <button
            @click="saveandsubmitForApproval()"
            class="btn btn-success"
            style="margin-left:15px;"
            v-if="documentStatus=='N' || documentStatus=='S' || documentStatus==null"
          >
            {{documentStatus=='S' ? 'Re-' : ''}}Submit
            {{masterData.isMigrated != 'Yes' ? ' for Approval' : ''}}
          </button>
        </div>
      </div>
    </div>

    <w-add-branch
      v-if="triggerAddBranchModal"
      :trigger="triggerAddBranchModal"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :isEdit="isEditBranch"
      :isCustomer="true"
      :pId="currentViewPartnerId"
      :selectedCompanyCode="form.companyCode"
      :editBranchDetails="editBranch"
      @eventClose="closeAddBranchModal()"
    />
    <w-bank
      v-if="triggerBankModal"
      :trigger="triggerBankModal"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :isEdit="isEditBankClicked"
      :editBankDetail="editBank"
      :isCustomer="true"
      :categoryCode="selectedCategory"
      :customerCompanyCode="form.companyCode"
      :customerPartnerId="currentViewPartnerId"
      @afterSave="callWidget()"
      @eventClose="closeBankModal()"
    />
    <widgetModal
      :trigger="triggerModal"
      :text="lastResponse"
      :title="modalTitle"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :modalbuttonStyle="true"
      :showAlert="failureModal"
      :showSuccess="successModal"
      @eventClose="changeModalStatus()"
    />
  </div>
</template>

<script>
import SummaryNavbar from "../components/summary/summaryNavbar";
import TextArea from "../widgets/TextArea";
import LoadingSpinner from "../widgets/LoadingSpinner";
import widgetModal from "../widgets/newModalWidget";
import moment from "moment";
import { SummaryServices } from "../services/summaryService";
const summaryService = new SummaryServices();
import multiSelect from "vue-multi-select";
import Datepicker from "vuejs-datepicker";
import AddBranchModal from "../widgets/AddBranchModal";

import { RegistrationService } from "../services/RegistrationService.js";
const RegisterService = new RegistrationService();
import bankModal from "../widgets/PPQuicklinkBankModal";
import { OnBoardingServices } from "../services/onBoardingService";
const OnBoardingService = new OnBoardingServices();
import TextInput from "../widgets/RegisterTextInput";
import DropDown from "../widgets/DropDown";

import { VueGoodTable } from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
import { AESService } from "../services/AES.js";
let aesService = new AESService();
import FileUploader from "../widgets/FileUploader.vue";
export default {
  components: {
    "c-summary-navbar": SummaryNavbar,
    "w-text-area": TextArea,
    "w-loading-spinner": LoadingSpinner,
    multiSelect,
    Datepicker,
    widgetModal,
    "w-dropdown": DropDown,
    "w-text-input": TextInput,
    FileUploader,
    "w-bank": bankModal,
    "w-add-branch": AddBranchModal,
    VueGoodTable
  },
  props: ["uid", "auditNo", "documentNo", "RefId", "companyCode", "source"],
  data() {
    return {
      currentPerPage: 50,
      searchTerm: "",
      currentPage: 0,
      totalRecords: "",
      isBranch: false,
      workflowRemarks: "",
      masterData: {},
      documentNumber: "",
      documentStatus: "",
      customerBranchList: [],
      customerBankList: [],
      viewPI: "",
      currentViewPartnerId: "",
      columns: [
        {
          label: "Partner Number",
          field: "partnerNumber",
          type: "String"
        },
        {
          label: "Customer Type",
          field: "parentCategory",
          type: "String"
        },
        {
          label: "Customer Name",
          field: "companyName",
          type: "String"
        },
        {
          label: "Country",
          field: "country",
          type: "String"
        },
        {
          label: "ID Card Value",
          field: "idcardValue",
          type: "String"
        },
        {
          label: "Actions",
          field: "actions",
          html: true
        }
      ],
      isCreate: false,
      isView: false,
      editBank: [],
      customerList: [1, 2, 3, 2, 2, 2, 2, 3],
      categoryList: [{ text: "Select One", value: null, disabled: true }],
      companyList: [{ text: "Select One", value: null, disabled: true }],
      isEditClicked: false,
      triggerBankModal: false,
      loading: false,
      docSearch: "",
      answerNumber: "",
      userId: "",
      userCode: "",
      eipUserName: "",
      auditNo: "",
      orderTypeCode: "",
      OverAllSubmitApprover: false,
      openTrackingModal: false,
      openWorkflowHistoryModal: false,
      partnerLoadig: false,
      overAllremarks: "",
      enableSubmit: true,
      actionStatus: "",
      failureModal: false,
      triggerModal: false,
      successModal: false,
      alertModal: false,
      lastResponse: "",
      madatoryFileds: false,
      encryptsecret: atob(process.env.VUE_APP_S_S),
      selectedNature: "",
      selectedSector: "",
      selectedGroup: "",
      countryList: [],
      sectorList: [{ text: "Select One", value: null, disabled: true }],
      natureList: [{ text: "Select One", value: null, disabled: true }],
      customerGroupList: [{ text: "Select One", value: null, disabled: true }],
      stateList: [],
      cityList: [],
      phoneNumberLength: 15,
      isdCode: "",
      gstDuplicate: false,
      tanDuplicate: false,
      vatDuplicate: false,
      companyCode: 1,
      wantToAddBranch: false,
      triggerAddBranchModal: false,
      editBranch: [],
      isEditBranch: false,
      form: {
        customerName: "",
        sector: "",
        nature: "",
        customerGroup: "",
        categoryCode: "",
        companyCode: "",
        address: {
          streetAddress: "",
          countryCode: "",
          stateCode: "",
          cityCode: ""
        },
        contact: { email: "", mobileNumber: "", contactName: "" },
        countryCode: 100,
        statutory: {
          panNumber: "",
          tanNumber: "",
          gstNumber: "",
          cinNumber: "",
          isGstNumber: "Y",
          gstinDocumentId: "",
          tanNumber: "",
          isTanNumber: "Y",
          tanDocumentId: "",
          vatNumber: "",
          isVatNumber: "Y",
          vatDocumentId: ""
        },
        financial: { turnover: "", gstRefNumber: "", itrRefNumber: "" }
      },
      onboardingDetails: {
        categoryCode: "",
        companyCode: "",
        gstNumber: "",
        gstinDeclarationDocumentId: "",
        gstinDocumentId: "",
        partnerId: "",
        ratings: [
          {
            agencyName: "",
            agencyRating: "",
            ratingAgencyCode: "",
            ratingDocumentId: "",
            slNo: ""
          }
        ],
        registeredOfficeAddress: {
          cityCode: "",
          countryCode: "",
          postalCode: "",
          slNo: "",
          stateCode: "",
          streetAddress: ""
        },
        tanDocumentId: "",
        tanNumber: "",
        vatDocumentId: "",
        vatNumber: "",
        year1: {
          assets: "0",
          balanceSheetAttachment: "",
          bsOrItr: "Y",
          grossProfit: "100",
          itrAttachment: "",
          itrDate: "",
          itrReference: "",
          netProfit: "",
          roa: "",
          roce: "",
          turnover: "",
          year: ""
        }
      }
    };
  },
  created() {
    var self = this;
    //
    if (this.uid) {
      this.getQueryFromUrl();
    } else {
      this.decryptfunction();
    }
    //$(document).on('click', '[id^="view"]', function(e){
    //if(this.currentDocuNumberForAction != e.target.id.split('~~~')[1]) {
    //  e.preventDefault();
    //  e.stopPropagation();
    //self.goToDetails(e.target.id.split('~~~')[1],e.target.id.split('~~~')[2],e.target.id.split('~~~')[3]
    //,e.target.id.split('~~~')[4])
    //}
    //})
  },

  mounted() {
    var self = this;
    EventBus.$on("customerBankAdded", function(e) {
      self.getCustomerBankList();
    });
    EventBus.$on("customerBranchAdded", function(e) {
      self.getCustomerBranchList();
    });
  },
  watch: {
    searchTerm: function(newVal, oldVal) {
      if (newVal.length < oldVal.length && newVal.length < 4) {
        this.searchTerm = "";
        this.getCustomerList();
      }
    }
  },
  methods: {
    encrypt(text, i) {
      var CryptoJS = require("crypto-js");
      var encrypted = {};
      var ciphertext = CryptoJS.AES.encrypt(
        JSON.stringify(text),
        this.encryptsecret
      );
      encrypted = {
        key: ciphertext.key + "", // don't send this
        iv: ciphertext.iv + "", // don't send this
        salt: ciphertext.salt + "", // don't send this
        ciphertext: ciphertext.ciphertext + "", // don't send this
        str: ciphertext + "" // send or store this
      };
      sessionStorage.setItem("summaryToken", encrypted.str);
    },
    getAttachmentName(documentId) {
      let attachmentName = "";
      attachmentName = documentId.split(/_(.+)/)[1]
        ? documentId.split(/_(.+)/)[1]
        : documentId;
      return attachmentName;
    },
    goToEIP4() {
      location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL);
    },
    onSearch() {
      if (this.searchTerm.length > 3) {
        this.getCustomerList();
      }
    },
    onPageChange(params) {
      this.currentPage = params.currentPage - 1;
      this.currentPerPage = params.currentPerPage;
      this.getCustomerList();
    },
    deleteBankDetail(b) {
      if (window.confirm("Do you want to delete this bank entry?")) {
        var data = {
          categoryCode: 5,
          companyCode: this.form.companyCode,
          partnerId: this.currentViewPartnerId,
          slNo: b.slNo
        };
        OnBoardingService.deleteCustomerDraftBank(data)
          .then(res => {
            this.loading = false;
            console.log(res);
            if (res.failureMessage != "") {
              window.alert(res.failureMessage);
            } else {
              window.alert(res.response);
              this.getCustomerBankList();
            }
          })
          .catch(error => {
            console.log(error);
            window.alert(error);
            if (error.failureMessage != "") {
              window.alert(error.failureMessage);
            } else {
              window.alert("something went wrong!");
            }
          });
      }
    },
    deleteBranchDetail(b) {
      if (window.confirm("Do you want to delete this branch entry?")) {
        var data = {
          categoryCode: 5,
          companyCode: this.form.companyCode,
          partnerId: this.currentViewPartnerId,
          branchId: b.branchId
        };
        OnBoardingService.deleteCustomerDraftBranch(data)
          .then(res => {
            this.loading = false;
            console.log(res);
            if (res.failureMessage != "") {
              window.alert(res.failureMessage);
            } else {
              window.alert(res.response);
              this.getCustomerBranchList();
            }
          })
          .catch(error => {
            console.log(error);
            window.alert(error);
            if (error.failureMessage != "") {
              window.alert(error.failureMessage);
            } else {
              window.alert("something went wrong!");
            }
          });
      }
    },
    getCustomerBankList() {
      this.loading = true;
      var data = {
        categoryCode: 5,
        companyCode: this.form.companyCode,
        partnerId: this.currentViewPartnerId
      };
      OnBoardingService.getCustomerBankList(data)
        .then(res => {
          this.loading = false;
          this.customerBankList = res.response;
        })
        .catch(error => {
          window.alert("something went wrong!");
          console.log(error);
        });
    },
    getCustomerBranchList() {
      this.loading = true;
      var data = {
        categoryCode: 5,
        companyCode: this.form.companyCode,
        partnerId: this.currentViewPartnerId
      };
      OnBoardingService.getCustomerBranchList(data)
        .then(res => {
          this.loading = false;
          this.customerBranchList = res.response;
        })
        .catch(error => {
          window.alert("something went wrong!");
          console.log(error);
        });
    },
    zipValidation(countryCode) {
      if (countryCode == 100) {
        return "required|max:6|min:6|regex_zip_code";
      } else {
        return "required|regex_intl_zip_code";
      }
    },
    viewDetails(row) {
      this.goToDetails(
        row.companyCode,
        row.partnerId,
        row.categoryCode,
        row.partnerNumber
      );
    },
    resetForm() {
      this.masterData = {};
      this.selectedSector = "";
      this.selectedNature = "";
      this.selectedGroup = "";
      this.documentStatus = "";
      this.documentNumber = "";
      this.workflowRemarks = "";
      this.viewPI = "";
      this.form = {
        customerName: "",
        sector: "",
        nature: "",
        customerGroup: "",
        categoryCode: "",
        companyCode: "",
        address: {
          streetAddress: "",
          countryCode: "",
          stateCode: "",
          cityCode: ""
        },
        contact: { email: "", mobileNumber: "", contactName: "" },
        countryCode: 100,
        statutory: {
          panNumber: "",
          tanNumber: "",
          gstNumber: "",
          cinNumber: "",
          isGstNumber: "Y",
          gstinDocumentId: "",
          tanNumber: "",
          isTanNumber: "Y",
          tanDocumentId: "",
          vatNumber: "",
          isVatNumber: "Y",
          vatDocumentId: ""
        },
        financial: { turnover: "", gstRefNumber: "", itrRefNumber: "" }
      };
    },
    validateRegistration() {
      if (this.form.countryCode == 100) {
        if (
          !/^[a-zA-Z]{4,5}[0-9]{4,5}[a-zA-Z]{1}$/.test(
            this.form.statutory.panNumber
          )
        ) {
          window.alert("Invalid PAN Number Format");
          this.loading = false;
          return false;
        }
        if (!/^[1-9][0-9]{9}$/.test(this.form.contact.mobileNumber)) {
          window.alert("Mobile number should be 10 digits");
          this.loading = false;
          return false;
        }
      } else {
        if (!/^[a-zA-Z0-9]*$/.test(this.form.statutory.cinNumber)) {
          window.alert(
            "National Id must be only alpha numeric and cannot contain special characters"
          );
          this.loading = false;
          return false;
        }
        if (
          this.form.contact.mobileNumber.length < 6 ||
          this.form.contact.mobileNumber.length > 14
        ) {
          window.alert(
            "Mobile number should be atleast 6 digits and maximum 14 digits"
          );
          this.loading = false;
          return false;
        }
      }

      if (this.form.contact.email == "" || !this.form.contact.email) {
        window.alert("Email is required");
        this.loading = false;
        return false;
      }
      if (
        this.form.contact.mobileNumber == "" ||
        !this.form.contact.mobileNumber
      ) {
        window.alert("Mobile number is required");
        this.loading = false;
        return false;
      }
      if (
        this.form.contact.contactName == "" ||
        !this.form.contact.contactName
      ) {
        window.alert("Contact name is required");
        this.loading = false;
        return false;
      }
      if (this.form.customerName == "" || !this.form.customerName) {
        window.alert("Customer Name is required");
        this.loading = false;
        return false;
      }
      if (this.form.nature == "") {
        window.alert("Nature is required");
        this.loading = false;
        return false;
      }
      if (this.form.sector == "") {
        window.alert("Sector is required");
        this.loading = false;
        return false;
      }
      if (this.form.customerGroup == "") {
        window.alert("Customer Group is required");
        this.loading = false;
        return false;
      }
      if (this.form.companyCode == "" || !this.form.companyCode) {
        window.alert("Company Code is required");
        this.loading = false;
        return false;
      }

      if (!/^[A-Za-z0-9&-.\s]*$/.test(this.form.customerName)) {
        window.alert(
          "Customer name cannot contain special characters except & or -"
        );
        this.loading = false;
        return false;
      }
      if (
        this.form.statutory.panNumber.trim() != "" &&
        !/^([a-zA-Z0-9-]+\s?)*$/.test(this.form.statutory.panNumber)
      ) {
        window.alert("PAN Number cannot contain special characters");
        this.loading = false;
        return false;
      }
      if (
        this.form.statutory.cinNumber.trim() != "" &&
        !/^([a-zA-Z0-9-]+\s?)*$/.test(this.form.statutory.cinNumber)
      ) {
        window.alert("National Id cannot contain special characters");
        this.loading = false;
        return false;
      }
      if (!/^[A-Za-z0-9-\s]*$/.test(this.form.contactName)) {
        window.alert("Contact Name cannot contain special characters");
        this.loading = false;
        return false;
      }

      return true;
    },
    registerCustomer() {
      if (!this.validateRegistration()) {
        return false;
      }

      var data = {
        companyCode: this.form.companyCode,
        companyTypeCode: null,
        contactContactName: this.form.contact.contactName,
        contactDesignation: "",
        contactEmail: this.form.contact.email,
        contactFax: "",
        contactMobileNumber: this.form.contact.mobileNumber,
        contactTelPhoneNumber: "",
        countryCode: this.form.countryCode,
        customerNature: this.form.nature,
        customerSector: this.form.sector,
        customerGroup: this.form.customerGroup,
        dunsNumber: "",
        idCardCode: 1, //todo
        idCardValue: "",
        longDesc: this.form.customerName,
        partnerId: 0,
        primaryBusiness: 5,
        website: ""
      };

      if (this.form.countryCode != 100) {
        data.idCardValue = this.form.statutory.cinNumber;
      }
      if (this.form.countryCode == 100) {
        data.idCardValue = this.form.statutory.panNumber;
      }

      OnBoardingService.registerCustomer(data)
        .then(res => {
          this.loading = false;
          console.log(res);
          if (res.failureMessage != "") {
            window.alert(res.failureMessage);
          } else {
            window.alert(res.response.message);
            this.goToDetails(
              res.response.companyCode,
              res.response.partnerId,
              res.response.categoryCode,
              res.response.partnerNumber
            );
          }
        })
        .catch(error => {
          console.log(error);
          window.alert(error);
          if (error.failureMessage != "") {
            window.alert(error.failureMessage);
          } else {
            window.alert("something went wrong!");
          }
        });
    },

    saveCustomerDetails() {
      var data = {
        userId: this.userId,
        categoryCode: 5,
        companyCode: this.form.companyCode,
        gstNumber: this.onboardingDetails.gstNumber,
        gstinDeclarationDocumentId: this.onboardingDetails
          .gstinDeclarationDocumentId,
        gstinDocumentId: this.onboardingDetails.gstinDocumentId,
        partnerId: this.currentViewPartnerId,
        ratings: [
          {
            agencyName: "",
            agencyRating: this.onboardingDetails.ratings[0].agencyRating,
            ratingAgencyCode: "1",
            ratingDocumentId: this.onboardingDetails.ratings[0]
              .ratingDocumentId,
            slNo: 1
          }
        ],
        registeredOfficeAddress: {
          cityCode: this.onboardingDetails.registeredOfficeAddress.cityCode,
          countryCode: this.onboardingDetails.registeredOfficeAddress
            .countryCode,
          postalCode: this.onboardingDetails.registeredOfficeAddress.postalCode,
          slNo: 1,
          stateCode: this.onboardingDetails.registeredOfficeAddress.stateCode,
          streetAddress: this.onboardingDetails.registeredOfficeAddress
            .streetAddress
        },
        tanDocumentId: this.onboardingDetails.tanDocumentId,
        tanNumber: this.onboardingDetails.tanNumber,
        tanDeclarationDocumentId: this.onboardingDetails
          .tanDeclarationDocumentId,
        vatDocumentId: this.onboardingDetails.vatDocumentId,
        vatNumber: this.onboardingDetails.vatNumber,
        vatDeclarationDocumentId: this.onboardingDetails
          .vatDeclarationDocumentId,
        year1: {
          assets: null,
          balanceSheetAttachment: this.onboardingDetails.year1
            .balanceSheetAttachment,
          bsOrItr: "Y",
          grossProfit: null,
          itrAttachment: this.onboardingDetails.year1.itrAttachment,
          itrDate: null,
          itrReference: this.onboardingDetails.year1.itrReference,
          netProfit: null,
          roa: null,
          roce: null,
          turnover: this.onboardingDetails.year1.turnover,
          year: new Date().getFullYear() - 1
        }
      };

      OnBoardingService.saveCustomerDetails(data)
        .then(res => {
          this.loading = false;
          console.log(res);
          if (res.failureMessage != "") {
            window.alert(res.failureMessage);
          } else {
            window.alert(res.response);
            this.goToDetails(
              this.form.companyCode,
              this.currentViewPartnerId,
              5,
              this.viewPI
            );
          }
        })
        .catch(error => {
          console.log(error);
          window.alert(error);
          if (error.failureMessage != "") {
            window.alert(error.failureMessage);
          } else {
            window.alert("something went wrong!");
          }
        });
    },

    saveandsubmitForApproval() {
      var self = this;
      if (
        this.documentStatus == "N" ||
        this.documentStatus == "S" ||
        this.documentStatus == null
      ) {
        var data = {
          userId: this.userId,
          categoryCode: 5,
          companyCode: this.form.companyCode,
          gstNumber: this.onboardingDetails.gstNumber,
          gstinDeclarationDocumentId: this.onboardingDetails
            .gstinDeclarationDocumentId,
          gstinDocumentId: this.onboardingDetails.gstinDocumentId,
          partnerId: this.currentViewPartnerId,
          ratings: [
            {
              agencyName: "",
              agencyRating: this.onboardingDetails.ratings[0].agencyRating,
              ratingAgencyCode: "1",
              ratingDocumentId: this.onboardingDetails.ratings[0]
                .ratingDocumentId,
              slNo: 1
            }
          ],
          registeredOfficeAddress: {
            cityCode: this.onboardingDetails.registeredOfficeAddress.cityCode,
            countryCode: this.onboardingDetails.registeredOfficeAddress
              .countryCode,
            postalCode: this.onboardingDetails.registeredOfficeAddress
              .postalCode,
            slNo: 1,
            stateCode: this.onboardingDetails.registeredOfficeAddress.stateCode,
            streetAddress: this.onboardingDetails.registeredOfficeAddress
              .streetAddress
          },
          tanDocumentId: this.onboardingDetails.tanDocumentId,
          tanNumber: this.onboardingDetails.tanNumber,
          tanDeclarationDocumentId: this.onboardingDetails
            .tanDeclarationDocumentId,
          vatDocumentId: this.onboardingDetails.vatDocumentId,
          vatNumber: this.onboardingDetails.vatNumber,
          vatDeclarationDocumentId: this.onboardingDetails
            .vatDeclarationDocumentId,
          year1: {
            assets: null,
            balanceSheetAttachment: this.onboardingDetails.year1
              .balanceSheetAttachment,
            bsOrItr: "Y",
            grossProfit: null,
            itrAttachment: this.onboardingDetails.year1.itrAttachment,
            itrDate: null,
            itrReference: this.onboardingDetails.year1.itrReference,
            netProfit: null,
            roa: null,
            roce: null,
            turnover: this.onboardingDetails.year1.turnover,
            year: new Date().getFullYear() - 1
          }
        };

        OnBoardingService.saveCustomerDetails(data)
          .then(res => {
            this.loading = false;
            console.log(res);
            if (res.failureMessage != "") {
              window.alert(res.failureMessage);
            } else {
              self.submitForApproval();
            }
          })
          .catch(error => {
            console.log(error);
            window.alert(error);
            if (error.failureMessage != "") {
              window.alert(error.failureMessage);
            } else {
              window.alert("something went wrong!");
            }
          });
      } else {
        self.submitForApproval();
      }
    },
    submitForApproval() {
      var self = this;
      var data = {
        actionStatus: 1,
        categoryCode: 5,
        companyCode: this.form.companyCode,
        partnerId: this.currentViewPartnerId,
        userId: this.userId
      };
      if (this.validateSubmitForApproval()) {
        if (
          window.confirm(
            "Do you want to submit this customer profile for approval workflow. Click OK to confirm?"
          )
        ) {
          OnBoardingService.customerSubmitForApproval(data)
            .then(res => {
              this.loading = false;
              console.log(res);
              if (res.failureMessage != "") {
                window.alert(res.failureMessage);
              } else {
                window.alert(res.response);
                //this.goToDetails(this.form.companyCode,this.currentViewPartnerId, 5, this.viewPI)
                self.$router.go(0);
              }
            })
            .catch(error => {
              console.log(error);
              window.alert(error);
              if (error.failureMessage != "") {
                window.alert(error.failureMessage);
              } else {
                window.alert("something went wrong!");
              }
            });
        }
      } else {
        return false;
      }
    },
    validateSubmitForApproval() {
      if (
        !(
          this.onboardingDetails.registeredOfficeAddress.postalCode &&
          this.onboardingDetails.registeredOfficeAddress.stateCode &&
          this.onboardingDetails.registeredOfficeAddress.cityCode &&
          this.onboardingDetails.registeredOfficeAddress.streetAddress &&
          this.onboardingDetails.registeredOfficeAddress.countryCode
        )
      ) {
        window.alert("Please fill all details in Address section");
        return false;
      }
      if (this.onboardingDetails.registeredOfficeAddress.countryCode == 100) {
        if (
          !this.onboardingDetails.gstNumber &&
          !this.onboardingDetails.gstinDocumentId &&
          !this.onboardingDetails.gstinDeclarationDocumentId
        ) {
          window.alert("Please fill GST Number section");
          return false;
        }
        if (
          this.onboardingDetails.gstNumber &&
          !this.onboardingDetails.gstinDocumentId
        ) {
          window.alert("Please attach GST certificate");
          return false;
        } else if (
          !this.onboardingDetails.gstNumber &&
          !this.onboardingDetails.gstinDeclarationDocumentId
        ) {
          window.alert("Please attach no GST declaration");
          return false;
        }

        if (
          !this.onboardingDetails.tanNumber &&
          !this.onboardingDetails.tanDocumentId &&
          !this.onboardingDetails.tanDeclarationDocumentId
        ) {
          window.alert("Please fill TAN Number section");
          return false;
        }
        if (
          this.onboardingDetails.tanNumber &&
          !this.onboardingDetails.tanDocumentId
        ) {
          window.alert("Please attach TAN certificate");
          return false;
        } else if (
          !this.onboardingDetails.tanNumber &&
          !this.onboardingDetails.tanDeclarationDocumentId
        ) {
          window.alert("Please attach no TAN declaration");
          return false;
        }
      } else {
        if (
          !this.onboardingDetails.vatNumber &&
          !this.onboardingDetails.vatDocumentId &&
          !this.onboardingDetails.vatDeclarationDocumentId
        ) {
          window.alert("Please fill VAT Number section");
          return false;
        }
        if (
          this.onboardingDetails.vatNumber &&
          !this.onboardingDetails.vatDocumentId
        ) {
          window.alert("Please attach VAT number proof");
          return false;
        } else if (
          !this.onboardingDetails.vatNumber &&
          !this.onboardingDetails.vatDeclarationDocumentId
        ) {
          window.alert("Please attach no VAT declaration");
          return false;
        }
      }

      if (this.gstDuplicate || this.tanDuplicate || this.vatDuplicate) {
        window.alert("Check for duplicate GST/TAN or VAT");
        return false;
      }

      if (this.gstDuplicate || this.tanDuplicate || this.vatDuplicate) {
        window.alert("Check for duplicate GST/TAN or VAT");
        return false;
      }

      if (!this.onboardingDetails.year1.turnover) {
        window.alert("Last financial year turn over is required");
        return false;
      }
      if (!this.onboardingDetails.year1.balanceSheetAttachment) {
        window.alert("Last financial year balance sheet is required");
        return false;
      }

      if (
        this.onboardingDetails.registeredOfficeAddress.countryCode == 100 &&
        !this.onboardingDetails.year1.itrReference
      ) {
        window.alert(
          "Last financial year ITR filing acknowledgement number is required"
        );
        return false;
      }

      if (
        this.onboardingDetails.registeredOfficeAddress.countryCode == 100 &&
        !this.onboardingDetails.year1.itrAttachment
      ) {
        window.alert("Last financial year ITR filing attachment is required");
        return false;
      }

      /*if(this.customerBankList.length == 0  || (this.customerBankList.length > 0 && 
      (this.customerBankList.filter(x=>x.accountCategory=='Primary')).length == 0)){
            window.alert("Add atleast one primary bank")
            return false
      }*/

      return true;
    },
    resetFilter() {
      this.searchTerm = "";
      this.currentPage = 0;
      this.currentPerPage = 50;
    },
    getCustomerList() {
      this.loading = true;
      OnBoardingService.getCustomerList(
        this.currentPage,
        this.currentPerPage,
        this.searchTerm
      )
        .then(res => {
          this.loading = false;
          if (res.failureMessage == "") {
            this.customerList = res.response.customerList;
            this.totalRecords = res.response.totalElements;
            //this.customerList.map(x => x.pOrB = x.partnerNumber && x.partnerNumber.substring(12,15) == '000' ? 'Parent' : 'Branch')
          } else {
            window.alert(res.failureMessage);
          }
        })
        .catch(error => {
          window.alert("something went wrong!");
          console.log(error);
        });
    },
    goToDetails(companyCode, partnerId, categoryCode, partnerNumber) {
      var self = this;
      this.searchTerm = "";
      this.currentPage = 0;
      this.currentPerPage = 50;
      this.currentViewPartnerId = partnerId;
      var data = {
        categoryCode: categoryCode,
        companyCode: companyCode,
        partnerId: partnerId
      };

      OnBoardingService.getCustomerDetails(data)
        .then(res => {
          this.loading = false;
          console.log(res);
          if (res.failureMessage != "") {
            window.alert(res.failureMessage);
          } else {
            this.isView = true;
            this.viewPI = partnerNumber;
            this.isBranch =
              partnerNumber.substring(12, 15) == "000" ? false : true;
            this.populateCustomerDetails(res.response);
            this.workflowRemarks = res.response.remarks;
            this.masterData = res.response;
            self.getCustomerBranchList();
            self.getCustomerBankList();
          }
        })
        .catch(error => {
          console.log(error);
          window.alert(error);
          if (error.failureMessage != "") {
            window.alert(error.failureMessage);
          } else {
            window.alert("something went wrong!");
          }
        });
    },
    getStatus() {
      var color = "";
      var value = "";
      if (this.documentStatus == "C") {
        value = "Approval in progress";
        color = "orange";
      }
      if (this.documentStatus == "N") {
        value = "Draft";
        color = "#f5f520";
      }
      if (this.documentStatus == "A") {
        value = "Approved";
        color = "green";
      }
      if (this.documentStatus == "S") {
        value = "Sentback";
        color = "blue";
      }
      if (this.documentStatus == "R") {
        value = "Rejected";
        color = "red";
      }

      return `<span style="color:${color}">${value}</span>`;
    },
    populateCustomerDetails(customerObj) {
      this.documentNumber = customerObj.documentNumber;
      this.documentStatus = customerObj.status;
      this.form.countryCode = customerObj.countryCode;

      this.$root.isInternational =
        customerObj.countryCode == 100 ? false : true;
      this.onboardingDetails.registeredOfficeAddress.countryCode =
        customerObj.countryCode;
      this.getStateList(customerObj.countryCode);
      this.getCityList(customerObj.registeredOfficeAddress.stateCode);
      this.form.companyCode = customerObj.companyCode;
      if (customerObj.countryCode == 100) {
        this.form.statutory.panNumber = customerObj.idCardValue;
      } else {
        this.form.statutory.cinNumber = customerObj.idCardValue;
      }
      this.form.contact.contactName = customerObj.contactContactName;
      this.form.contact.email = customerObj.contactEmail;
      this.form.contact.mobileNumber = customerObj.contactMobileNumber;
      this.form.customerName = customerObj.longDesc;

      this.form.nature = customerObj.customerNature;
      this.selectedNature = customerObj.customerNature;

      this.form.sector = customerObj.customerSector;
      this.selectedSector = customerObj.customerSector;

      this.form.customerGroup = customerObj.customerGroup;
      this.selectedGroup = customerObj.customerGroup;

      this.onboardingDetails.registeredOfficeAddress.postalCode =
        customerObj.registeredOfficeAddress.postalCode;
      this.onboardingDetails.registeredOfficeAddress.stateCode =
        customerObj.registeredOfficeAddress.stateCode;
      this.onboardingDetails.registeredOfficeAddress.cityCode =
        customerObj.registeredOfficeAddress.cityCode;
      this.onboardingDetails.registeredOfficeAddress.streetAddress =
        customerObj.registeredOfficeAddress.streetAddress;

      this.onboardingDetails.gstNumber = customerObj.gstNumber;
      this.onboardingDetails.gstinDocumentId = customerObj.gstinDocumentId;
      this.onboardingDetails.gstinDeclarationDocumentId =
        customerObj.gstinDeclarationDocumentId;

      if (
        this.onboardingDetails.gstNumber == null ||
        this.onboardingDetails.gstNumber == ""
      ) {
        this.form.statutory.isGstNumber = "N";
      } else {
        this.form.statutory.isGstNumber = "Y";
      }

      this.onboardingDetails.tanNumber = customerObj.tanNumber;
      this.onboardingDetails.tanDocumentId = customerObj.tanDocumentId;
      this.onboardingDetails.tanDeclarationDocumentId =
        customerObj.tanDeclarationDocumentId;

      if (
        this.onboardingDetails.tanNumber == null ||
        this.onboardingDetails.tanNumber == ""
      ) {
        this.form.statutory.isTanNumber = "N";
      } else {
        this.form.statutory.isTanNumber = "Y";
      }
      this.onboardingDetails.vatNumber = customerObj.vatNumber;
      this.onboardingDetails.vatDocumentId = customerObj.vatDocumentId;
      this.onboardingDetails.vatDeclarationDocumentId =
        customerObj.vatDeclarationDocumentId;

      if (
        this.onboardingDetails.vatNumber == null ||
        this.onboardingDetails.vatNumber == ""
      ) {
        this.form.statutory.isVatNumber = "N";
      } else {
        this.form.statutory.isVatNumber = "Y";
      }

      this.onboardingDetails.year1.balanceSheetAttachment =
        customerObj.year1.balanceSheetAttachment;
      this.onboardingDetails.year1.turnover = customerObj.year1.turnover;
      this.onboardingDetails.year1.itrAttachment =
        customerObj.year1.itrAttachment;
      this.onboardingDetails.year1.itrReference =
        customerObj.year1.itrReference;
      this.onboardingDetails.ratings[0].agencyRating =
        customerObj.ratings.length > 0
          ? customerObj.ratings[0].agencyRating
          : "";
      this.onboardingDetails.ratings[0].ratingDocumentId =
        customerObj.ratings.length > 0
          ? customerObj.ratings[0].ratingDocumentId
          : "";
    },
    closeBankModal() {
      this.triggerBankModal = false;
      this.isEditBankClicked = false;
      this.editBank = [];
    },
    getCompanies() {
      RegisterService.getPartnerList().then(resp => {
        let res = resp.response;
        for (let i = 0; i < res.length; i++) {
          this.companyList.push({
            text: res[i].name,
            value: res[i].companyCode
          });
        }
      });
    },
    getCategories(event) {
      this.categoryList = [];
      RegisterService.getBussiness(event).then(resp => {
        let res = resp.response;
        for (let i = 0; i < res.length; i++) {
          this.categoryList.push({
            text: res[i].longDesc,
            value: res[i].categoryCode
          });
        }
      });
    },
    closeAddBranchModal() {
      this.triggerAddBranchModal = false;
      this.getselectedBranchType(1);
      this.closeAction();
    },
    getselectedBranchType(event) {
      this.selectedBranchType = event;
      if (event == 1) {
        this.wantToAddBranch = true;
        this.enableFinancialYear = false;
        //this.getPartnerSavedBranches();
      }
      if (event == 2) {
        this.enableFinancialYear = true;
        this.wantToAddBranch = false;
      }
    },
    closeAction(global) {},
    showAttachFile(event) {
      this.loading = true;
      OnBoardingService.downLoadDocument(event).then(res => {
        this.loading = false;
      });
    },
    getFileName(fileName) {
      if (fileName != null) {
        var fileNameFinal = null;
        fileNameFinal = fileName.split(/_(.+)/)[1];
        return fileNameFinal;
      }
      return fileNameFinal;
    },
    uploadDocument(event, type) {
      let data = new FormData();
      let file = event[0];
      // data.append("name", "my-file");
      data.append("file", file);
      this.loading = true;

      OnBoardingService.uploadAttachments(data)
        .then(resp => {
          if (resp) {
            this.loading = false;
            if (type == "gst" && this.form.statutory.isGstNumber == "Y") {
              this.onboardingDetails.gstinDocumentId = resp.UniqueID;
            } else if (
              type == "gst" &&
              this.form.statutory.isGstNumber == "N"
            ) {
              this.onboardingDetails.gstinDeclarationDocumentId = resp.UniqueID;
            } else if (
              type == "tan" &&
              this.form.statutory.isTanNumber == "Y"
            ) {
              this.onboardingDetails.tanDocumentId = resp.UniqueID;
            } else if (
              type == "tan" &&
              this.form.statutory.isTanNumber == "N"
            ) {
              this.onboardingDetails.tanDeclarationDocumentId = resp.UniqueID;
            } else if (type == "bs") {
              this.onboardingDetails.year1.balanceSheetAttachment =
                resp.UniqueID;
            } else if (type == "itr") {
              this.onboardingDetails.year1.itrAttachment = resp.UniqueID;
            } else if (type == "gstFiling") {
              this.onboardingDetails.gstFilingDocId = resp.UniqueID;
            } else if (
              type == "vat" &&
              this.form.statutory.isVatNumber == "Y"
            ) {
              this.onboardingDetails.vatDocumentId = resp.UniqueID;
            } else if (
              type == "vat" &&
              this.form.statutory.isVatNumber == "N"
            ) {
              this.onboardingDetails.vatDeclarationDocumentId = resp.UniqueID;
            } else if (type == "rating") {
              this.onboardingDetails.ratings[0].ratingDocumentId =
                resp.UniqueID;
            }
          }
        })
        .catch(error => {
          this.triggerModal = true;
          this.loading = false;
          this.triggerModal = true;
          this.lastResponse = " Try After Sometime";
          this.alertsuccess = true;
        });
    },
    getGstNumber(event) {
      this.statutory = true;
      this.onboardingDetails.gstNumber = event.toUpperCase();
      if (event.length > 14) {
        OnBoardingService.checkCustomerGSTNumberWithPartnerId(
          event,
          this.currentViewPartnerId
        )
          .then(resp => {
            if (resp.failureMessage == "Not Available") {
              this.gstDuplicate = true;
            } else {
              this.gstDuplicate = false;
            }
          })
          .catch(error => {
            this.triggerModal = true;
            this.loading = false;
            this.triggerModal = true;
            this.lastResponse = "Something Went Wrong";
            this.alertsuccess = true;
          });
      } else {
        this.gstDuplicate = false;
      }
    },

    getTanNumber(event) {
      this.statutory = true;
      this.onboardingDetails.tanNumber = event.toUpperCase();
      if (event.length > 9) {
        OnBoardingService.checkCustomerTANNumberWithPartnerId(
          event,
          this.currentViewPartnerId
        )
          .then(resp => {
            if (resp.failureMessage == "Not Available") {
              this.tanDuplicate = true;
            } else {
              this.tanDuplicate = false;
            }
          })
          .catch(error => {
            this.triggerModal = true;
            this.loading = false;
            this.triggerModal = true;
            this.lastResponse = "Something Went Wrong";
            this.alertsuccess = true;
          });
      } else {
        this.tanDuplicate = false;
      }
    },
    getVatNumber(event) {
      this.statutory = true;
      this.onboardingDetails.vatNumber = event.toUpperCase();
      if (event.length > 4) {
        OnBoardingService.checkCustomerVATNumberWithPartnerId(
          event,
          this.currentViewPartnerId
        )
          .then(resp => {
            if (resp.failureMessage == "Not Available") {
              this.vatDuplicate = true;
            } else {
              this.vatDuplicate = false;
            }
          })
          .catch(error => {
            this.triggerModal = true;
            this.loading = false;
            this.triggerModal = true;
            this.lastResponse = "Something Went Wrong";
            this.alertsuccess = true;
          });
      } else {
        this.vatDuplicate = false;
      }
    },
    checkRadioGst() {
      this.onboardingDetails.gstNumber = null;
      this.onboardingDetails.gstinDocumentId = null;
      this.onboardingDetails.gstinDeclarationDocumentId = null;
    },
    checkRadioTan() {
      this.onboardingDetails.tanNumber = null;
      this.onboardingDetails.tanDocumentId = null;
      this.onboardingDetails.tanDeclarationDocumentId = null;
    },
    checkRadioVat() {
      this.onboardingDetails.vatNumber = null;
      this.onboardingDetails.vatDocumentId = null;
      this.onboardingDetails.vatDeclarationDocumentId = null;
    },
    getCustomerName(e) {
      this.form.customerName = e;
    },
    getSectorChange(e) {
      this.form.sector = e;
      this.selectedSector = e;
    },
    getCompanyChange(e) {
      this.form.companyCode = e;
      //this.getCategories(e);
    },
    getTurnOver(e) {
      this.onboardingDetails.year1.turnover = e;
    },
    getITRFilingNumber(event) {
      this.onboardingDetails.year1.itrReference = event;
    },
    getCrislRating(e) {
      this.onboardingDetails.ratings[0].agencyRating = e.toUpperCase();
    },
    getCategoryChange(e) {
      this.form.categoryCode = e;
    },
    getNatureChange(e) {
      this.form.nature = e;
      this.selectedNature = e;
    },
    getGroupChange(e) {
      this.form.customerGroup = e;
      this.selectedGroup = e;
    },
    getMobileNumber(e) {
      this.form.contact.mobileNumber = e;
    },
    getEmailId(e) {
      this.form.contact.email = e;
    },
    getContactName(e) {
      this.form.contact.contactName = e;
    },
    getPan(e) {
      this.form.statutory.cinNumber = "";
      this.form.statutory.panNumber = e.toUpperCase();
    },
    getCRN(e) {
      this.form.statutory.panNumber = "";
      this.form.statutory.cinNumber = e.toUpperCase();
    },

    mobileValidationObj() {
      if (!this.$root.isInternational) {
        return { required: true, regex_mobile_number: true, length: 10 };
      } else {
        return { required: true, min: 6, max: 14 };
      }
    },
    zipValidation(countryCode) {
      if (countryCode == 100) {
        return "required|max:6|min:6|regex_zip_code";
      } else {
        return "required|regex_intl_zip_code";
      }
    },
    getCountriesForCorrespondOffice() {
      this.countryList = [];
      OnBoardingService.getCountriesForRegdOffice().then(resp => {
        resp.response.forEach(country => {
          this.countryList.push({
            text: country.longDesc,
            value: country.countryCode,
            isdCode: country.isdCode
          });
        });
        // this.regOfficeCountryList = resp;
      });
    },
    getSectors() {
      this.sectorList = [];
      OnBoardingService.getSectors().then(resp => {
        resp.response.forEach(s => {
          this.sectorList.push({
            text: s.displayName,
            value: s.miscTypeDetailsCode,
            code: s.miscTypeDetailsCode
          });
        });
      });
    },
    getCustomerGroups() {
      this.customerGroupList = [];
      OnBoardingService.getCustomerGroups().then(resp => {
        resp.response.forEach(s => {
          this.customerGroupList.push({
            text: s.displayName,
            value: s.miscTypeDetailsCode,
            code: s.miscTypeDetailsCode
          });
        });
      });
    },
    getNatures() {
      this.natureList = [];
      OnBoardingService.getNatures().then(resp => {
        resp.response.forEach(n => {
          this.natureList.push({
            text: n.displayName,
            value: n.miscTypeDetailsCode,
            code: n.miscTypeDetailsCode
          });
        });
      });
    },
    getCountry(e) {
      this.form.statutory.panNumber = "";
      this.form.statutory.cinNumber = "";
      this.form.address.countryCode = e;
      this.form.countryCode = e;
      this.$root.isInternational = e == 100 ? false : true;
      this.onboardingDetails.registeredOfficeAddress.countryCode = e;
      this.isdCode =
        "+" + this.countryList.filter(x => x.value == e)[0].isdCode;
      this.getStateList(e);
    },
    getState(e) {
      this.onboardingDetails.registeredOfficeAddress.stateCode = e;
      this.getCityList(e);
    },
    getStreetAddress(e) {
      this.onboardingDetails.registeredOfficeAddress.streetAddress = e;
    },
    getCity(e) {
      this.onboardingDetails.registeredOfficeAddress.cityCode = e;
    },
    getZipcode(e) {
      this.onboardingDetails.registeredOfficeAddress.postalCode = e;
    },
    getCityList(e) {
      var self = this;
      this.cityList = [];
      var cityList = [];
      OnBoardingService.getCityForRegisteredOffice(e).then(resp => {
        resp.response.forEach(city => {
          cityList.push({
            text: city.cityName,
            value: city.cityCode
          });
        });
        this.$forceUpdate();
        return (this.cityList = cityList);
      });
    },
    getStateList(e) {
      var self = this;
      this.stateList = [];
      var statelist = [];
      OnBoardingService.getStatesForRegisteredOffice(e).then(resp => {
        resp.response.forEach(state => {
          statelist.push({
            text: state.longDescr,
            value: state.stateCode
          });
        });
        this.$forceUpdate();
        return (this.stateList = statelist);
      });
    },
    goToVendorMaster() {
      let routeData = this.$router.resolve({ name: "ForensicsDashboard" }); //, query: {data: ""}
      window.open(routeData.href, "_blank");
    },
    getRoleName(frCode) {
      if (frCode == 0) {
        return "Partner";
      }
      return this.frRolesList.filter(x => x.frCode == frCode).length > 0
        ? this.frRolesList.filter(x => x.frCode == frCode)[0].longDesc
        : "Not available";
    },

    EncodeUsingAES(value) {
      var CryptoJS = require("crypto-js");
      if (value === undefined || value === null) {
        return "";
      } else {
        const keys = atob(process.env.VUE_APP_E_4);
        const key = CryptoJS.enc.Utf8.parse(keys);
        const vectorIV = CryptoJS.enc.Utf8.parse(keys);
        const encrypted = CryptoJS.AES.encrypt(
          CryptoJS.enc.Utf8.parse(value.toString()),
          key,
          {
            keySize: 128 / 8,
            iv: vectorIV,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
          }
        );
        return encrypted.toString();
      }
    },
    encrypt(text, i) {
      var CryptoJS = require("crypto-js");
      var encrypted = {};
      var ciphertext = CryptoJS.AES.encrypt(
        JSON.stringify(text),
        this.encryptsecret
      );
      encrypted = {
        key: ciphertext.key + "", // don't send this
        iv: ciphertext.iv + "", // don't send this
        salt: ciphertext.salt + "", // don't send this
        ciphertext: ciphertext.ciphertext + "", // don't send this
        str: ciphertext + "" // send or store this
      };
      sessionStorage.setItem("summaryToken", encrypted.str);
      this.$router.push({ name: this.url });
    },
    formatDateTime(dt, splitter) {
      console.log(dt);
      var dateArray = dt.split(splitter)[0].split("-");
      var timeArray = dt.split(splitter)[1].split(":");
      var date = dateArray[2];
      var month = dateArray[1];
      var year = dateArray[0];
      var h = timeArray[0];
      var m = timeArray[1];

      var ampm = h >= 12 ? "PM" : "AM";
      h = h > 12 ? h - 12 : h;
      h = h.toString().length == 1 ? "0" + h : h;
      return date + "-" + month + "-" + year + " " + h + ":" + m + " " + ampm;
    },
    getStatusText(statusCode) {
      if (statusCode == 1) {
        return "Approved";
      } else if (statusCode == 2) {
        return "SendBack";
      } else if (statusCode == 3) {
        return "Rejected";
      } else if (statusCode == 4) {
        return "Requested";
      } else if (statusCode == 5) {
        return "PartialApproved";
      } else if (statusCode == 6) {
        return "AutoCancel";
      } else if (statusCode == 7) {
        return "Created";
      } else if (statusCode == 8) {
        return "Resolved";
      } else if (statusCode == 9) {
        return "Closed";
      } else if (statusCode == 10) {
        return "Forwarded";
      } else if (statusCode == 11) {
        return "Reopened";
      }
    },
    decryptfunction() {
      var self = this;
      var CryptoJS = require("crypto-js");
      var token = sessionStorage.getItem("summaryToken");
      self.companyCodeToPass = sessionStorage.getItem("companyCode");
      var bytes =
        token &&
        CryptoJS.AES.decrypt(token.toString(), atob(process.env.VUE_APP_S_S));
      var decryptedData =
        bytes && JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      if (decryptedData) {
        this.answerNumber = decryptedData.decodedRequestNumber;
        this.userId = decryptedData.eipUsersUserid;
        this.userCode = decryptedData.evaluatorsFRCode;
        this.eipUserName = decryptedData.eipUserName;
        this.auditNo = decryptedData.auditNumber;
      }

      sessionStorage.setItem("useridadmin", this.userId);
      summaryService
        .getAdminApplicable(
          this.companyCodeToPass,
          decryptedData.eipActualUserId
        )
        .then(res => {
          this.loading = false;
          if (res.status == "SUCCESS") {
            self.allowViewCustomerDashboard = res.response;
            if (res.response) {
              this.getCustomerList();
              this.getCompanies();
              this.getCountriesForCorrespondOffice();
              this.getSectors();
              this.getNatures();
              this.getCustomerGroups();
            } else {
              window.alert("You are not provided access to view this page");
              location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL);
            }
          } else {
            window.alert(res.failureMessage);
          }
        })
        .catch(err => {
          this.loading = false;
          window.alert("Error getting access details.");
          location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL);
        });
      this.getAllInfo();
    },

    getQueryFromUrl() {
      sessionStorage.setItem("refId", this.RefId);
      sessionStorage.setItem("companyCode", this.companyCode);
      sessionStorage.setItem(
        "source",
        this.source == undefined || this.source == "undefined"
          ? ""
          : this.source
      );
      sessionStorage.setItem("eipSessionId", this.auditNo);
      var data = {
        eipUserId: this.uid,
        encodedRequestNumber: this.documentNo,
        eipSessionId: this.auditNo,
        latitude: null,
        location: null,
        loginFrom: "Onboard WorkFlow",
        longitude: null,
        companyCode: this.companyCode,
        source:
          this.source == undefined || this.source == "undefined"
            ? ""
            : this.source
      };
      var sessionData = {
        userid: this.uid,
        usercode: this.auditNo
      };
      (data.latitude = this.latitude), (data.longitude = this.longitude);
      data.isCustomer = "true";
      summaryService
        .intermediatePage(data)
        .then(resp => {
          if (resp.response.userDetails) {
            /*if (resp.response.userDetails.menuUrl == "FeedbackApproval") {
              this.url = "PartnerApproval";
            } else {
              this.url = resp.response.userDetails.menuUrl;
            }*/
            //window.alert(resp.response.userDetails.menuUrl)
            //this.url = "Workbench"
            //this.isLoading = false;
            this.encrypt(resp.response.userDetails);
            sessionStorage.setItem(
              "sessiontimeout",
              JSON.stringify(sessionData)
            );
            sessionStorage.setItem("eipUserId", this.uid);
            sessionStorage.setItem("auditNo", this.auditNo);
            sessionStorage.setItem("encodedRequestNumber", this.documentNo);
            sessionStorage.setItem("eipSessionId", this.auditNo);
            this.decryptfunction();
          } else {
            this.isLoading = false;
            if (resp.failureMessage) {
              alert(resp.failureMessage);
              location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL);
            }
          }
        })
        .catch(err => {
          this.isLoading = false;
          console.log(err);
          var errorMsg =
            err && err.failureMessage
              ? err.failureMessage
              : "Something went wrong. Try again later.";
          alert(errorMsg);
          location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL);
        });
    },
    openTrackingStatus(answerNumber) {
      this.currentDocuNumberForAction = answerNumber;
      this.loading = true;
      summaryService
        .getWorkFlowHistory(answerNumber)
        .then(res => {
          this.loading = false;
          if (res.status == "SUCCESS") {
            this.originalArray = res.response.workflows;
            this.frRolesList = res.response.frRolesList;
            this.traceData = [];
            var n = [];
            //n.push(this.originalArray[0])
            for (var i = 0; i < this.originalArray.length; i++) {
              if (this.originalArray[i].actionStatus == 6) {
                continue;
              }
              if (this.originalArray.length - 1 == i) {
                n.push(this.originalArray[i]);
                this.traceData.push(n);
                n = [];
              } else if (this.originalArray[i].actionStatus != 2) {
                n.push(this.originalArray[i]);
              } else if (this.originalArray[i].actionStatus == 2) {
                n.push(this.originalArray[i]);
                this.traceData.push(n);
                n = [];
              }
            }
            var lastArray = this.traceData[this.traceData.length - 1];
            var allfour = lastArray.filter(x => x.actionStatus == 4);
            if (allfour.length == lastArray.length) {
              for (var j = 0; j < lastArray.length; j++) {
                lastArray[j]["isShow"] = true;
              }
            }
            this.traceData[this.traceData.length - 1] = lastArray;
            //this.traceData[0][0]["frCode"] = 0
            console.log(this.traceData);
          } else {
            this.triggerModal = true;
            this.loading = false;
            this.failureModal = false;
            this.lastResponse = res.failureMessage;
            this.alertModal = true;
          }
          this.openTrackingModal = true;
        })
        .catch(err => {
          this.loading = false;
          this.triggerModal = true;
          this.loading = false;
          this.lastResponse = err.failureMessage
            ? err.failureMessage
            : "Something went wrong. Try again later.";
          this.alertModal = true;
        });
      /*summaryService.getTrackingData(answerNumber)
        .then(res => {
          this.loading = false;
          this.trackingData = res.response.status;
          this.roleName = res.response.evaluatorsName;
      this.openTrackingModal = true;
        })
        .catch(err => {
          this.loading = false;
        });*/
    },
    closeTrackingModal() {
      this.openTrackingModal = false;
    },
    getCreatedDate(date) {
      return moment(date).format("DD-MMM-YYYY hh:mm A");
    },
    getAllInfo() {
      if (this.userCode == 103) {
        //this.loading = false;
        this.userName = "buyer";
        this.protalName = "Buyer";
      } else if (this.userCode == 104) {
        //this.loading = false;
        this.userName = "technical";
        this.protalName = "Technical";
      } else if (this.userCode == 105) {
        //this.loading = false;
        this.userName = "commercial";
        this.protalName = "Commercial";
      } else if (this.userCode == 106) {
        //this.loading = false;
        this.userName = "approver";
        this.protalName = "Approver";
      } else if (this.userCode == 107) {
        //this.loading = false;
        this.userName = "projecthead";
        this.protalName = "Project Head";
      } else if (this.userCode == 108) {
        //this.loading = false;
        this.userName = "icscmhead";
        this.protalName = "ICSCM Head";
      } else if (this.userCode == 109) {
        //this.loading = false;
        this.userName = "buhead";
        this.protalName = "BU Head";
      }
    },
    documentApprover(value) {
      if (this.moduleWorkflow == "PTM") {
        if (this.effectiveToDate == "" || this.effectiveFromDate == "") {
          this.triggerModal = true;
          this.alertModal = true;
          this.lastResponse = "Please fill the Testimonial duration";
        } else {
          this.actionStatus = value;
          this.overAllremarks = "";
          this.enableSubmit = true;
          this.OverAllSubmitApprover = true;
        }
      } else if (this.moduleWorkflow == "PBC") {
        if (this.userName == "buyer") {
          this.actionStatus = value;
          this.getContigentRadioValue();
          this.getContigentJob();
        } else {
          this.overallRemarkspopUp = "";
          this.enableSubmit = true;
          this.OverAllSubmitApprover = true;
        }
      } else {
        this.actionStatus = value;
        this.overAllremarks = "";
        this.enableSubmit = true;
        this.OverAllSubmitApprover = true;
      }
    },
    sendBack(value) {
      this.actionStatus = value;
      this.overAllremarks = "";
      this.enableSubmit = true;
      this.OverAllSubmitApprover = true;
    },
    rejectReview(value) {
      this.actionStatus = value;
      this.overAllremarks = "";
      this.enableSubmit = true;
      this.OverAllSubmitApprover = true;
    },
    getOverallRemarks(event) {
      if (event.length > 2) {
        this.enableSubmit = false;
      } else {
        this.enableSubmit = true;
      }
      this.overAllremarks = event;
      if (this.moduleWorkflow == "PBC") {
        this.overallRemarkspopUp = event;
      }
    },
    dottedStatus(status) {
      if (status == "Approved") {
        return "dottedGreen";
      }
      if (status == "Sendback") {
        return "dottedSendback";
      }
      if (status == "Rejected") {
        return "dottedRejected";
      }
      if (status == "Pending") {
        return "dottedPending";
      }
    },
    getUserInputValue(event) {
      this.companyCode = event.companyCode;
      this.orderTypeCode = event.orderType;
    },
    overAllSumbit() {
      if (this.moduleWorkflow == "PTM") {
        var testimonialsApproveData = {
          actionStatus: this.actionStatus,
          effectiveFromDate: this.effectiveFromDate,
          effectiveToDate: this.effectiveToDate,
          requestNumber: this.answerNumber,
          userId: this.userId
        };
        this.loading = true;
        summaryService
          .testimonialsApproval(testimonialsApproveData)
          .then(res => {
            if (res.status == "SUCCESS") {
              this.triggerModal = true;
              this.loading = false;
              this.successModal = true;
              this.lastResponse = "Document Approved Sucessfully";
              sessionStorage.clear();
            } else {
              this.triggerModal = true;
              this.loading = false;
              this.lastResponse = res.failureMessage;
              this.alertModal = true;
            }
          })
          .catch(error => {
            this.triggerModal = true;
            this.loading = false;
            this.lastResponse = error.failureMessage;
            this.alertModal = true;
          });
      } else if (this.moduleWorkflow == "PBC") {
        this.OverAllSubmitApprover = false;
        this.showContigentPopUp = false;
        let reviewObject = {};
        reviewObject.actionStatus = this.actionStatus;
        reviewObject.requestNumber = this.answerNumber;
        reviewObject.userId = this.userId;
        reviewObject.remarks = this.overallRemarkspopUp;
        reviewObject.auditNumber = this.auditNo;
        reviewObject.segregatorToBuyers = [];
        reviewObject.classificationCode = this.contigentValue;
        reviewObject.jobCode =
          this.selectedJobValue.length == 0
            ? null
            : this.selectedJobValue[0].value;
        reviewObject.exceptedEndDate = this.contigentEndDate;
        reviewObject.orginType =
          this.selectedJobValue.length == 0
            ? null
            : this.selectedJobValue[0].orgin;
        this.loading = true;
        // console.log(reviewObject)
        if (reviewObject) {
          console.log(reviewObject);
          summaryService
            .buyerActionBusinessCategories(reviewObject)
            .then(res => {
              if (res.status == "SUCCESS") {
                this.triggerModal = true;
                this.loading = false;
                this.successModal = true;
                if (this.actionStatus == "3") {
                  this.lastResponse =
                    "Business Categories Rejected Sucessfully";
                } else if (this.actionStatus == "1") {
                  this.lastResponse =
                    "Business Categories Approved Sucessfully";
                }
                sessionStorage.clear();
              } else {
                this.triggerModal = true;
                this.loading = false;
                this.lastResponse = res.failureMessage;
                this.alertModal = true;
              }
            })
            .catch(error => {
              this.triggerModal = true;
              this.loading = false;
              this.lastResponse = error.failureMessage;
              this.alertModal = true;
            });
        }
      } else {
        if (this.moduleWorkflow == "feedback") {
          var formdata = {
            actionStatus: this.actionStatus,
            auditNumber: this.auditNo,
            remarks: this.overAllremarks,
            documentNumber: this.answerNumber,
            companyCode: this.companyCode,
            orderTypeCode: this.orderTypeCode,
            userId: this.userId
          };
        } else {
          var formdata = {
            actionStatus: this.actionStatus,
            auditNumber: this.auditNo,
            remarks: this.overAllremarks,
            requestNumber: this.answerNumber,
            segregatorToBuyers: [],
            userId: this.userId
          };
        }

        this.loading = true;
        summaryService
          .summaryAction(formdata, this.moduleWorkflow, this.userName)
          .then(resp => {
            if (resp.status == "SUCCESS") {
              this.triggerModal = true;
              this.loading = false;
              this.successModal = true;
              this.lastResponse = resp.response;
              sessionStorage.clear();
            } else {
              this.triggerModal = true;
              this.loading = false;
              this.lastResponse = resp.failureMessage;
              this.alertModal = true;
            }
          })
          .catch(error => {
            this.triggerModal = true;
            this.loading = false;
            this.lastResponse = error.failureMessage;
            this.alertModal = true;
          });
      }
    },
    partnerApproval() {
      this.loading = true;
      summaryService
        .summaryAction()
        .then(resp => {
          if (resp.status == "SUCCESS") {
            this.loading = false;
            this.successModal = true;
            this.lastResponse = resp.response;
            sessionStorage.clear();
          } else {
            this.loading = false;
            this.lastResponse = resp.failureMessage;
            this.alertModal = true;
          }
        })
        .catch(error => {
          this.loading = false;
          this.lastResponse = error.failureMessage;
          this.alertModal = true;
        });
    },
    changeModalStatus() {
      this.triggerModal = false;
      this.successModal = false;
      this.enterAllDetails = false;
      this.ratingsEmpty = false;
      this.failureModal = false;
    },
    changeModalSuccess() {
      sessionStorage.removeItem("token");
      location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL);
    },
    closeModal() {
      if (this.lastResponse == "Please fill the Testimonial duration") {
        this.triggerModal = false;
        this.alertModal = false;
        this.lastResponse = "";
      } else {
        sessionStorage.removeItem("token");
        location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL);
      }
    },
    logout() {
      let data = {};
      var logouttime = new Date();
      data.lastActionTime = null;
      data.loginAuditNumber = aesService.EncodeUsingAES(this.auditNo);
      data.logoutTime = logouttime;
      data.logoutType = "U";
      summaryService
        .userLogout(data)
        .then(res => {
          sessionStorage.clear();
          location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL);
        })
        .catch(err => {
          location.replace(process.env.VUE_APP_SUMMARYREDIRECT_URL);
        });
    },
    getTestimonialDuration(event) {
      console.log(event);
      this.effectiveFromDate = event.effectiveFrom;
      this.effectiveToDate = event.effectiveUpto;
      console.log(this.effectiveFromDate);
      console.log(this.effectiveToDate);
    },
    closeSecondaryModal() {
      this.showContigentPopUp = false;
    },
    getJobdate(event) {
      this.contigentEndDate = event;
    },
    checkMandatoryFields() {
      if (this.contigentValue == 1) {
        if (this.overallRemarkspopUp == "") {
          this.madatoryFileds = true;
          return true;
        } else {
          this.madatoryFileds = false;
          return false;
        }
      }
      if (this.contigentValue == 2) {
        if (
          this.selectedJobValue.length == 0 ||
          this.contigentEndDate == "" ||
          this.overallRemarkspopUp == ""
        ) {
          this.madatoryFileds = true;
          return true;
        } else {
          this.madatoryFileds = false;
          return false;
        }
      }
    },
    getContigentRadioValue() {
      this.loading = true;
      summaryService
        .getContigentRadioInputValue(this.answerNumber)
        .then(resp => {
          if (resp.response) {
            console.log(resp);
            this.loading = false;
            this.showContigentPopUp = true;
            this.radioInputValue = resp.response;
            if (this.radioInputValue.length == 1) {
              this.contigentValue = this.radioInputValue[0].classificationCode;
            }
            // this.contigentValue = 2;
          } else {
            this.loading = false;
            this.triggerModal = true;
            this.lastResponse = resp.failureMessage;
            this.alertModal = true;
          }
          // this.radioInputValue.push({});
        });
    }
  }
};
</script>

<style scoped>
.th-left th {
  text-align: left !important;
}
.disabled {
  pointer-events: none;
  opacity: 0.7;
  background: #ececec;
  cursor: none;
}
.customerlist th {
  text-align: left;
}
.sub-heading {
  font-size: 13px;
  font-weight: 600;
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  text-align: left;
  color: #000000;
}
.headingss {
  font-weight: bold;
  font-size: 14px;
  text-align: left;
}
.customerregform {
  text-align: left !important;
}
.field-headings {
  text-align: left !important;
}
</style>
<style>
.model-content {
  width: 100% !important;
}
.modal-header {
  font-family: "Source Sans Pro", sans-serif;
  padding: 2% !important;
  color: white;
  background-image: linear-gradient(to bottom, #1d76ae, #055396);
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.modal-footer > .btn-primary {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  text-align: center;
  color: white !important;
  /* border-radius: 2px; */
  background-color: #1579ab;
}
.summaryNavbar {
  background-color: #14436a;
}
.approverButton {
  font-size: 16px;
  font-weight: 600;
  color: white;
  cursor: pointer;
  font-family: "Source Sans Pro", sans-serif;
  outline: none !important;
  padding: 3%;
  float: left;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.approverstatus {
  font-size: 16px;
  font-weight: 600;
  color: white;
  cursor: pointer;
  font-family: "Source Sans Pro", sans-serif;
  outline: none !important;
  padding: 3%;
  float: left;
  margin-left: 40%;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.role-Name {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 13px;
  font-weight: bold;
  text-decoration: underline;
  margin-bottom: 10% !important;
}
.dottedPending {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #f4cf08;
  float: left;
  margin-top: 2%;
}
.dottedGreen {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #28b915;
  float: left;
  margin-top: 3%;
}
.popOverRemarks {
  cursor: pointer;
  float: left;
  font-size: 12px;
  color: #747474;
  text-decoration: underline;
  outline: none !important;
}
.popOverDate {
  float: left;
  font-size: 12px;
  color: #747474;
}
.vgt-table th {
  padding: 5px 10px !important;
  font-size: 14px !important;
  background-color: #1a72ab !important;
  background: #1a72ab !important;
  color: #fff !important;
}
table.vgt-table td {
  padding: 5px 10px !important;
  font-size: 14px !important;
}
table.vgt-table tr:nth-child(even) {
  background-color: #f2f2f2;
}
.footer__row-count__select {
  width: 30px !important;
  padding: 5px !important;
}
.custom-btn {
  padding: 0px 10px;
  background-color: #09599a;
}
#vendor-details,
#workflow-history {
  max-width: 250px;
  display: inline-block;
}
.query-pane button {
  background-color: #09599a;
  margin-left: 10px;
  height: 32px;
  margin-top: -4px;
}
.wb-head {
  text-align: left;
  padding-left: 25px;
  font-size: 20px;
  font-weight: bold;
}
.modal-fullscreen {
  max-width: 100%;
}
.modal-fullscreen .modal-dialog {
  width: 100% !important;
  max-width: 100% !important;
}

.modal-fullscreen .modal-dialog .modal-content {
  width: 95% !important;
}
.wf-history-table {
  width: 100%;
}
.wf-history-table td {
  padding: 10px;
}
.text-green {
  color: green;
  font-weight: bold;
}
.text-red {
  color: red;
  font-weight: bold;
}
.text-yellow {
  color: #dec300;
  font-weight: bold;
}
.text-orange {
  color: orange;
  font-weight: bold;
}
.bold {
  font-weight: bold;
}
.trace-wrap {
  height: 20px;
  overflow: hidden;
  white-space: nowrap;
  max-width: 200px;
  text-overflow: ellipsis;
}
.trace-wrap div {
  overflow: hidden;
  text-overflow: ellipsis;
}

.linker {
  float: right;
  padding-right: 22px;
  font-weight: bold;
  color: #005aff;
  font-size: 18px;
  text-decoration: underline;
  cursor: pointer;
}
.vgt-table th,
.vgt-table td {
  max-width: 400px !important;
  overflow: auto;
  word-break: break-all;
}
.vgt-fixed-header {
  display: none !important;
}
</style>
